import { FormGroup, FormControl } from '@angular/forms';
import { BaseComponent } from './base.component';

export class InsuranceBase extends BaseComponent {

    constructor() {
        super();
    }
}
